<div class="flex-control flex-column programs-module">
  <app-tabs>
    <li (click)="tabs_service.deactivate_tab()" [class.active]="!tabs_service.is_active()">Private Program</li>
  </app-tabs>
  <app-programs-listing class="flex-control flex-column" [hidden]="tabs_service.is_active()" [programme_category]="'private_programme'"></app-programs-listing>
</div>
